import { render, staticRenderFns } from "./LIAContacts.vue?vue&type=template&id=18636667&scoped=true"
import script from "./LIAContacts.vue?vue&type=script&lang=js"
export * from "./LIAContacts.vue?vue&type=script&lang=js"
import style0 from "./LIAContacts.vue?vue&type=style&index=0&id=18636667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18636667",
  null
  
)

export default component.exports